import getFieldRenderObject from '../../../utils/newforms/render/getFieldRenderObject'
import { INDEXATION_MODE_OPTIONS, REVIEW_STATUS_OPTIONS } from './defaultSeo'

/** Form fields for full landing SEO (globalCategories, brands). */
export class FullLandingSeoForm {
  constructor() {
    this.title = {
      field: {
        fieldId: 'title',
        fieldType: 'input',
        label: 'SEO title',
        required: false,
        value: '',
      },
      render: getFieldRenderObject(),
    }
    this.metaDescription = {
      field: {
        fieldId: 'metaDescription',
        fieldType: 'textarea',
        label: 'Meta description',
        required: false,
        value: '',
      },
      render: getFieldRenderObject(),
    }
    this.ogTitle = {
      field: {
        fieldId: 'ogTitle',
        fieldType: 'input',
        label: 'OG title',
        required: false,
        value: '',
      },
      render: getFieldRenderObject(),
    }
    this.ogDescription = {
      field: {
        fieldId: 'ogDescription',
        fieldType: 'textarea',
        label: 'OG description',
        required: false,
        value: '',
      },
      render: getFieldRenderObject(),
    }
    this.h1 = {
      field: {
        fieldId: 'h1',
        fieldType: 'input',
        label: 'H1',
        required: false,
        value: '',
      },
      render: getFieldRenderObject(),
    }
    this.introText = {
      field: {
        fieldId: 'introText',
        fieldType: 'texteditor',
        label: 'SEO intro text',
        required: false,
        value: '',
      },
      render: getFieldRenderObject(),
    }
    this.bottomText = {
      field: {
        fieldId: 'bottomText',
        fieldType: 'texteditor',
        label: 'SEO bottom text',
        required: false,
        value: '',
      },
      render: getFieldRenderObject(),
    }
    this.reviewStatus = {
      field: {
        fieldId: 'reviewStatus',
        fieldType: 'select',
        label: 'SEO review status',
        required: false,
        getOptions: REVIEW_STATUS_OPTIONS,
      },
      render: getFieldRenderObject(),
    }
    this.indexationMode = {
      field: {
        fieldId: 'indexationMode',
        fieldType: 'select',
        label: 'Indexation mode',
        required: false,
        getOptions: INDEXATION_MODE_OPTIONS,
      },
      render: getFieldRenderObject(),
    }
  }
}
